import Vue from 'vue';
import VueSession from 'vue-session';

// install session mechanism
// see https://github.com/victorsferreira/vue-session
Vue.use(VueSession, {
  persist: true,
});
